export * from './toast.message';
export * from './platform-notifications.message';
export * from './auth-tenant-selection-failed';
export * from './auth-reauthentication-required';

import { AuthTenantSelectionFailedMessageTemplateComponent } from './auth-tenant-selection-failed';
import { AuthReauthenticationRequiredMessageTemplateComponent } from './auth-reauthentication-required';

export const NotificationMessageTemplates = [
	AuthTenantSelectionFailedMessageTemplateComponent,
	AuthReauthenticationRequiredMessageTemplateComponent,	
];